export enum InstagramReactions {
  COMMENT,
  REPLY
}
